import { render, staticRenderFns } from "./DLGContactMe.vue?vue&type=template&id=76931972&"
import script from "./DLGContactMe.vue?vue&type=script&lang=js&"
export * from "./DLGContactMe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\UBoss\\Source\\Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76931972')) {
      api.createRecord('76931972', component.options)
    } else {
      api.reload('76931972', component.options)
    }
    module.hot.accept("./DLGContactMe.vue?vue&type=template&id=76931972&", function () {
      api.rerender('76931972', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/featureOnePage/webParts/callToAction/DLGContactMe.vue"
export default component.exports